import { SharedModule } from 'src/app/shared/shared.module'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { DeviceLockGuard } from './device-lock.guard'
import { DeviceEffects } from './device.effects'
import * as fromDevice from './device.reducer'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(fromDevice.FEATURE_NAME, fromDevice.deviceReducer),
    EffectsModule.forFeature([DeviceEffects])
  ],
  declarations: [],
  providers: [DeviceLockGuard]
})
export class DeviceModule {}
